const routes = [
	{
		path: "/",
		alias: '/index' ,
		name: "index",
		meta: {
			title: '主页',
		},
		redirect: "/order",
		component: () => import("../views/index.vue"),
		children: [
			{
				path: "/order",
				name: "order",
				meta: {
					title: '订单管理',
					icon:'el-icon-bank-card',
				},
				component: () => import("../views/page/order.vue")
			},
			{
				path: "/review-order",
				name: "review-order",
				meta: {
					title: '复核订单',
					icon:'el-icon-view',
				},
				component: () => import("../views/page/review-order.vue")
			},
			{
				path: "/user",
				name: "user",
				meta: {
					title: '用户管理',
					icon:'el-icon-user',
				},
				component: () => import("../views/page/user.vue")
			},
			{
				path: "/record",
				name: "record",
				meta: {
					title: '进店管理',
					icon:'el-icon-shopping-cart-full',
				},
				component: () => import("../views/page/record.vue")
			},
			{
				path: "/goods",
				name: "goods",
				meta: {
					title: '商品管理',
					icon:'el-icon-box',
				},
				component: () => import("../views/page/goods/index.vue"),
			},
			{
				path: "/activity",
				name: "activity",
				meta: {
					title: '限时活动管理',
					icon:'el-icon-present',
				},
				component: () => import("../views/page/activity/index.vue"),
			},
			{
				path: "/patrol-photo",
				name: "patrol-photo",
				meta: {
					title: '巡店记录',
					icon:'el-icon-camera',
				},
				component: () => import("../views/page/patrol-photo.vue"),
			},
			{
				path: "/new-product-photo",
				name: "new-product-photo",
				meta: {
					title: '产品上新记录',
					icon:'el-icon-picture-outline',
				},
				component: () => import("../views/page/new-product-photo.vue"),
			},
			{
				path: "/inspection-photo",
				name: "inspection-photo",
				meta: {
					title: '验货记录',
					icon:'el-icon-search',
				},
				component: () => import("../views/page/inspection-photo.vue"),
			},
		]
	},
	{
		path: "/login",
		name: "login",
		meta: {
			title: '登录',
		},
		component: () => import("../views/page/login.vue")
	},
];

export default routes;